module.exports = __webpack_public_path__ + "static/img/DJ.477c02d4.png";